/**
 * Returns a timestamp with X amount of days added to it.
 *
 * @param daysToPostpone How many days should be added to the current date.
 * @returns Timestamp
 */
export function getPostponedDate(daysToPostpone: number): number {
  const date = new Date();
  return date.setDate(date.getDate() + daysToPostpone);
}
